export default () => {
  return {
    namedLocations: [],
    alertSettings: [],
    locationHistory: []
  }
}
